export default __webpack_public_path__ + "static/media/setion03_kv02.05faf9ba.png";